import { useCallback, useRef } from 'react';

/**
 * 탭 전환 시 각 탭의 스크롤 위치를 기억하고 복원하는 훅
 *
 * - 탭 변경 시 현재 탭의 스크롤 위치 저장
 * - 새 탭으로 전환 후 해당 탭의 이전 스크롤 위치 복원
 */
export function useTabScrollMemory() {
  const scrollPositions = useRef<Record<string, number>>({});

  const handleTabChange = useCallback(
    (currentTab: string, newTab: string, setTab: (tab: string) => void) => {
      // 현재 탭의 스크롤 위치 저장
      scrollPositions.current[currentTab] = window.scrollY;

      // 탭 전환
      setTab(newTab);

      // 새 탭의 스크롤 위치 복원 (다음 프레임에서 - display 변경 반영 후)
      requestAnimationFrame(() => {
        const savedPosition = scrollPositions.current[newTab];
        if (savedPosition !== undefined) {
          window.scrollTo(0, savedPosition);
        }
        // 저장된 위치가 없으면 현재 위치 유지 (탭 바가 보이는 상태)
      });
    },
    [],
  );

  return { handleTabChange };
}
